module.exports = __webpack_public_path__ + "img/ring_g_i_1_null@3x.19e652c3.png";